export default {
  bind: function(el) {
    el.addEventListener('keydown', function(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        el.click();        
      }
    });
  }
}